/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewOTTResponse
 */
export interface CRSFSecReviewOTTResponse {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewOTTResponse
     */
    ott: string;
}

/**
 * Check if a given object implements the CRSFSecReviewOTTResponse interface.
 */
export function instanceOfCRSFSecReviewOTTResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ott" in value;

    return isInstance;
}

export function CRSFSecReviewOTTResponseFromJSON(json: any): CRSFSecReviewOTTResponse {
    return CRSFSecReviewOTTResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewOTTResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewOTTResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ott': json['ott'],
    };
}

export function CRSFSecReviewOTTResponseToJSON(value?: CRSFSecReviewOTTResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ott': value.ott,
    };
}

